import { Box, Card, CardHeader, CardMedia } from '@mui/material';
import CustomBlock from './CustomBlock';
import useEditorProps from '@hooks/useEditorProps';
import saveBlockHelper from '@assets/saveBlockHelper.png';
import { useTranslation } from 'react-i18next';

function SavedBlocks() {
    const { t } = useTranslation();
    const { savedBlocks } = useEditorProps();

    if (savedBlocks.length === 0) {
        return (
            <Card sx={{ borderRadius: 2, border: 1, borderColor: 'divider' }}>
                <CardHeader
                    title={t('Save Your First Block')}
                    titleTypographyProps={{ variant: 'subtitle1' }}
                    subheader={t(
                        'Select a block and click the save button to add your first block.',
                    )}
                    subheaderTypographyProps={{ variant: 'body2' }}
                />
                <CardMedia component="img" image={saveBlockHelper} />
            </Card>
        );
    }

    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr 1fr 1fr"
            gap={1}
            // padding={1}
            height="max-content"
        >
            {savedBlocks.map(block => (
                <CustomBlock key={block.id} item={block} />
            ))}
        </Box>
    );
}

export default SavedBlocks;
